import {systemFetch, autoFetch as fetch} from '@/utils/fetch';

// 新增报名公告
export function addVoteTwoRecruitNotice(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/addVoteTwoRecruitNotice',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据学校Id查询公告列表
export function getVoteTwoRecruitNoticeList() {
    return fetch({
        url: 'structure/voteTwo/getVoteTwoRecruitNoticeList',
        method: 'post'
    });
}

// 根据公告id删除公告
export function delVoteTwoRecruitNotice(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/voteTwo/delVoteTwoRecruitNotice',
        method: 'post',
        data: params
    });
}

// 根据公告id查询公告
export function getVoteTwoRecruitNotice(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/voteTwo/getVoteTwoRecruitNotice',
        method: 'post',
        data: params
    });
}

// 修改报名公告
export function updateVoteTwoRecruitNotice(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/updateVoteTwoRecruitNotice',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据公告id查询用户列表
export function getVoteTwoRecruitUserList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('searchTitle', args.searchTitle);
    params.append('pageSize', args.pageSize);
    params.append('pageNo', args.pageNo);

    return fetch({
        url: 'structure/voteTwo/getVoteTwoRecruitUserList',
        method: 'post',
        data: params
    });
}

//根据问卷Id和用户id查询问卷信息
export function getVoteByVoteIdAndUserId(args) {
    const params = new URLSearchParams();
    params.append('userId', args.userId);
    params.append('voteId', args.voteId);

    return fetch({
        url: 'structure/voteTwo/getVoteByVoteIdAndUserId',
        method: 'post',
        data: params
    });
}

//根据招生报名用户查询问卷信息
export function getVoteByRecruitUser(args) {
    const params = new URLSearchParams();
    params.append('cardId', args.cardId);
    params.append('voteId', args.voteId);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/voteTwo/getVoteByRecruitUser',
        method: 'post',
        data: params
    });
}

//新增学生家长
export function addStudentAndParent(args) {
    const params = new URLSearchParams();

    // params.append('classId', 0);
    // params.append('gender', args.gender);
    // params.append('learnNum', args.learnNum);
    // params.append('name', args.name);
    // params.append('relatives', args.relatives);
    // params.append('cardId', args.cardId);
    // params.append('cardType', args.cardType);

    params.append('recruitUserIds', args.recruitUserIds);
    // params.append('schoolYear', args.schoolYear);
    return fetch({
        url: 'structure/voteTwo/addStudentAndParent',
        method: 'post',
        data: params
    });
}

// 修改公告用户
export function updateVoteTwoRecruitUser(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/updateVoteTwoRecruitUser',
        method: 'post',
        data: JSON.stringify(args)
    });
}

export function exportVoteTwoRecruitUserList(args) {
    const params = new URLSearchParams();

    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/voteTwo/exportVoteTwoRecruitUserList',
        method: 'post',
        data: params
    });
}

// 获取学校短信模板
export function queryTemplateBySchoolId() {

    return fetch({
        url: 'structure/recruitMessageTemplate/queryTemplateBySchoolId',
        method: 'post',
    });
}

//发送短信口
export function sendSMS(args) {
    const params = new URLSearchParams();
    params.append('recruitUserIds', args.mobiles);
    // params.append('moduleCode', args.moduleCode);
    // params.append('moduleName', args.moduleName);
    params.append('smsContent', args.smsContent);
    params.append('schoolYear', args.schoolYear);
    params.append('templateName', args.templateName);
    params.append('templateCode', args.templateCode);
    params.append('templateParamJson', args.templateParamJson);
    return fetch({
        url: 'structure/voteTwo/sendSMS',
        method: 'post',
        data: params
    });
}


// 删除公告用户
export function delVoteTwoRecruitUser(args) {
    const params = new URLSearchParams();

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/delVoteTwoRecruitUser',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 删除公告用户
export function delVoteTwoRecruitUserCommon(args) {
    const params = new URLSearchParams();

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'common/voteTwo/delVoteTwoRecruitUser',
        method: 'post',
        data: JSON.stringify(args)
    });
}

//
export function jumpRecruitNoticeNum(args) {
    const params = new URLSearchParams();
    params.append('numCount', args.numCount);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/voteTwo/jumpRecruitNoticeNum',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/notice.js